import React, { memo, FC } from 'react';
import classNames from 'classnames';
import {
  makeStyles,
  tokens,
  shorthands,
  TableCellLayout,
  Tooltip,
  Text,
} from '@fluentui/react-components';

import { MetricPickerMenuButton } from './metric-picker-menu-button';
import { ISelectedMetric } from '../types';

export const useStyles = makeStyles({
  metricCell: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  metricCellContent: {
    display: 'flex',
  },
  metricCellHeaderText: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    ...shorthands.overflow('hidden'),
  },
  sorted: {
    backgroundColor: tokens.colorSubtleBackgroundHover,
  },
});

export interface IMetricHeaderCellProps {
  metricDisplayName: string;
  dropdownMetrics?: ISelectedMetric[];
  onMetricDropdownSelect?: (key: string) => void;
  i18n: any;
}

export const MetricHeaderCell: FC<IMetricHeaderCellProps> = memo(({
  metricDisplayName,
  dropdownMetrics,
  onMetricDropdownSelect,
  i18n,
}: IMetricHeaderCellProps) => {
  const classes = useStyles();
  return (
    <TableCellLayout truncate className={classNames('ba-performance-table-metric-cell-header', classes.metricCell)} >
      <div className={classNames('ba-performance-table-metric-cell-header-content', classes.metricCellContent)}>
        <Tooltip content={metricDisplayName} relationship="label">
          <Text weight="bold" className={classNames('ba-performance-table-metric-cell-header-text', classes.metricCellHeaderText)}>{metricDisplayName}</Text>
        </Tooltip>
        {dropdownMetrics?.length > 0 &&
          <MetricPickerMenuButton
            dropdownMetrics={dropdownMetrics}
            onMetricDropdownSelect={onMetricDropdownSelect}
            i18n={i18n}
          />
        }
      </div>
    </TableCellLayout>
  );
});

MetricHeaderCell.defaultProps = {
  dropdownMetrics: null,
  onMetricDropdownSelect: null,
};
